import { useEffect, useRef, useState } from 'react';

import { useQuery } from '@apollo/client/react';

import { ListingAccordion } from '@modules/_shared/components/ListingAccordion';
import {
  GET_CATCHMENT_AREA,
  UserCatchmentArea,
} from '@modules/users/UserCatchmentArea';
import { useLocale } from '@shared/hooks/locale';

type UserCatchmentAreaCardProps = {
  userId: string;
};

export const UserCatchmentAreaCard = ({
  userId,
}: UserCatchmentAreaCardProps) => {
  const { t } = useLocale();
  const { data, loading } = useQuery(GET_CATCHMENT_AREA, {
    variables: { userId },
  });
  const hasCatchmentArea =
    (data?.users_by_pk?.catchment_areas?.length ?? 0) > 0;
  const [expanded, setExpanded] = useState(false);
  const initialized = useRef(false);

  useEffect(() => {
    if (!loading && !initialized.current) {
      initialized.current = true;
      setExpanded(hasCatchmentArea);
    }
  }, [loading, hasCatchmentArea]);

  return (
    <ListingAccordion
      title={t('Catchment area')}
      expanded={expanded}
      onChange={(_event, isExpanded) => setExpanded(isExpanded)}
    >
      <UserCatchmentArea userId={userId} embedded />
    </ListingAccordion>
  );
};
